import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/event`;

class EventService {
    getAll() {
        return axios.get(`${API_URL}/all`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getEvent(id) {
        return axios.get(`${API_URL}/view/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilter(data) {
        return axios.get(`${API_URL}/getFilter`, {
            params: {
                coming: data.coming,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    add(event) {
        return axios.post(`${API_URL}/new`, event, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    update(event) {
        return axios.put(`${API_URL}/update`, event, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
}

export default new EventService();